export default __webpack_public_path__ + "static/media/profile.da6214a9.svg";